import React from "react";
import InputField from "../../components/CustomFields/InputField";

const ContactPerson = ({ applicant, handleNestedChange, errors }) => {
  return (
    <section className="p-4">
      <h2 className="text-lg font-bold mb-4 text-center">Contact Person</h2>

      {applicant.contactPersonList.map((contact, index) => {
        const contactErrors = errors?.contactPersonList?.[index] || {};

        return (
          <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
            <InputField
              id={`contactFirstName-${index}`}
              label="First Name *"
              value={contact.firstName}
              onChange={(e) =>
                handleNestedChange("contactPersonList", index, "firstName", e.target.value)
              }
              error={contactErrors.firstName}
            />

            <InputField
              id={`contactLastName-${index}`}
              label="Last Name *"
              value={contact.lastName}
              onChange={(e) =>
                handleNestedChange("contactPersonList", index, "lastName", e.target.value)
              }
              error={contactErrors.lastName}
            />

            <InputField
              id={`contactEmail-${index}`}
              label="Email *"
              value={contact.email}
              onChange={(e) =>
                handleNestedChange("contactPersonList", index, "email", e.target.value)
              }
              type="email"
              error={contactErrors.email}
            />

            <InputField
              id={`contactPhoneNumber-${index}`}
              label="Mobile Number *"
              value={contact.phoneNumber}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/[^\d]/g, "");
                const maxLength = 10;

                // Get country code from sessionStorage
                const countryCode = sessionStorage.getItem("selectedCountryCode");

                // Determine the phone prefix
                let prefix = "+91"; // default
                switch (countryCode) {
                  case "US":
                  case "CA":
                  case "MX":
                    prefix = "+1";
                    break;
                  case "IN":
                    prefix = "+91";
                    break;
                  default:
                    prefix = "+";
                    break;
                }

                // Remove any leading country code in the input if already typed
                let formattedValue = prefix + " ";
                if (inputValue.startsWith(prefix.replace("+", ""))) {
                  formattedValue += inputValue.slice(prefix.length - 1, prefix.length - 1 + maxLength);
                } else {
                  formattedValue += inputValue.slice(0, maxLength);
                }

                handleNestedChange("contactPersonList", index, "phoneNumber", formattedValue);
              }}
              onFocus={(e) => e.target.setSelectionRange(e.target.value.length, e.target.value.length)}
              inputProps={{ maxLength: 14 }}
              error={contactErrors.phoneNumber}
            />

          </div>
        );
      })}
    </section>
  );
};

export default ContactPerson;
